import { differenceInMonths } from 'date-fns';
// Helper to move the focus to the given moveCallback's date. It checks
// the availability of that date and moves forward until this date is enabled.
// If the entire month in the requested direction has no enabled dates,
// it returns the currently focused date.
var moveFocusHandler = function (focussed, isDateEnabled, moveCallback) {
    var current = moveCallback(focussed);
    if (!isDateEnabled) {
        return current;
    }
    while (!isDateEnabled(current)) {
        if (Math.abs(differenceInMonths(focussed, current)) > 1) {
            return focussed;
        }
        current = moveCallback(current);
    }
    return current;
};
export default moveFocusHandler;
//# sourceMappingURL=move-focus-handler.js.map